const defaultTranslations = {
  form_labels: {
    child_birthday: 'Child’s Birthday (Optional)',
    marketing_consent_html:
      '<p>I agree to receive marketing communications such as reward balance updates, offers, and promotions.</p>',
    terms_consent_html:
      '<p>I confirm I have read and accept the Shoes &amp; Sox Fit Club program <a href="/pages/terms-conditions">terms &amp; conditions</a> and <a href="/pages/privacy-policy">privacy policy</a>.</p>'
  },
  account_portal: {
    title: 'Login or create a Fit Club account',
    cta_text: 'Tell us more about you',
    brand_button: {
      text: 'Sign up',
      link: '/account/register'
    },
    sign_up_list: {
      item_1_icon: 'bag',
      item_1: 'Receive 10% cashback for your next order',
      item_2_icon: 'Birthday',
      item_2: 'Each child will enjoy a $10 birthday reward',
      item_3_icon: 'assign-shoe',
      item_3: 'Earn $2 for each shoe assigned to a child'
    },
    account_terms_conditions_html: "<p>*By registering, I agree to be a VIP in Shoes & Sox's VIP program & agree to Shoes & Sox's T&C's and how my data may be collected & used as set out in Shoes & Sox's <a target='_blank' href='/pages/privacy-policy'> privacy policy.</a></p>",
    sign_up_success_title: 'Check Your inbox',
    sign_up_success_description: "We've just sent you a message to access your secure profile. You can also show this barcode to the Shoes & Sox Expert Shoe Crew so they can quickly find your details.",
    sign_in_channel_email: 'Email',
    sign_in_channel_mobile: 'Mobile',
    sign_in_email_placeholder: 'Enter your email address',
    sign_in_mobile_placeholder: '412 345 678',
    sign_up_mobile_code_title: 'Enter the 6 digit code sent to:',
    sign_up_mobile_code_change: 'Change',
    sign_up_mobile_code_label: 'Verification code',
    sign_up_mobile_code_placeholder: 'Enter 6 digit code',
    sign_up_mobile_code_submit: 'Login to your account',
    sign_up_mobile_code_resend: 'Resend code',
    sign_up_mobile_code_resent: 'Code sent - check your messages',
    sign_up_mobile_code_resend_wait: 'Resend in {seconds}s',
    sign_up_success_add_child: 'Add Child Profile',
    sign_up_success_complete_later: 'Complete Later',
    sign_up_success_destination: 'Sent to {destination}',
    auth_errors: {
      network: 'We could not reach the server. Check your connection and try again.',
      rate_limited: 'Too many attempts. Please wait a moment, then try again.',
      not_found: 'No account found with that mobile number.',
      invalid_code: 'Incorrect code. Please check and try again.',
      expired_code: 'This code has expired. Please request a new one.',
      unknown: 'Something went wrong. Please try again.'
    },
    sign_up_mobile_code_description: "We've just sent a code to your mobile number. Please check your messages and enter the code to activate your account and access your profile."
  }
}

export const accountTranslations = window.globals?.translations || defaultTranslations
